import React from 'react';

import ListFilter, { ListFilterOption } from '../../../../components/ListFilter';
import { ALL_STATUS_FILTER_KEYS, StatusFilterKey } from '../../statusFilter.constants';
import { ApprovalStatus } from '../../types';
import getApprovalStatus from '../../utils/getApprovalStatus';

// Pastel fill per stage (matches the status Pill colours used in the leads
// table). EXPIRED's tone is dark enough to need a light label.
const STAGE_PILL_COLORS: Partial<Record<StatusFilterKey, { bg: string; text?: string }>> = {
    INITIAL_INTEREST: { bg: 'var(--lead-status-yellow)' },
    MEDICAL_CHECK_SCHEDULED: { bg: 'var(--lead-status-blue)' },
    MEDICAL_CHECK_MISSED: { bg: 'var(--lead-status-red)' },
    PENDING_ENROLLMENT: { bg: 'var(--lead-status-success)' },
    APPROVED: { bg: 'var(--lead-status-success)' },
    REJECTED: { bg: 'var(--lead-status-red)' },
    EXPIRED: { bg: 'var(--lead-status-grey)', text: 'var(--color-neutrals-background)' }
};

const StatusFilter: React.FC<{ inline?: boolean }> = ({ inline = false }) => {
    const options: ListFilterOption[] = React.useMemo(
        () =>
            ALL_STATUS_FILTER_KEYS.map((s) => {
                const color = STAGE_PILL_COLORS[s];
                return {
                    value: s,
                    label: getApprovalStatus(s).label,
                    activeColor: color?.bg,
                    activeTextColor: color?.text
                };
            }),
        []
    );

    const formatLabel = React.useCallback((selectedValues: string[]) => {
        if (selectedValues.length) {
            return selectedValues
                .map((s) => getApprovalStatus(s as ApprovalStatus).label)
                .join(', ');
        }

        return 'Stage: All';
    }, []);

    return (
        <ListFilter
            options={options}
            searchParam="approval_status"
            label="Stage"
            mode="multi"
            variant="pills"
            width="32rem"
            persistToLocalStorage
            resetPaginationKeys={['offset']}
            formatLabel={formatLabel}
            hasResetBtn
            inline={inline}
        />
    );
};

export default StatusFilter;
